import React, { PropsWithChildren } from 'react';
import { useRouter } from 'next/router';

import { useTrack } from '@blockworks/platform/services/analytics';
import { Button, FlexBox, Text } from '@blockworks/ui/components';

import { AnalyticsEvent } from '@/modules/utils/enums/events-tracking';

interface AuthStepHeaderProps extends PropsWithChildren {
    title: string;
    description: string;
}

const AuthStepHeader = ({ children, title, description }: AuthStepHeaderProps) => (
    <FlexBox col gap="md">
        {children}
        <Text size="display-sm" weight="medium">
            {title}
        </Text>
        <Text size="md" color="muted">
            {description}
        </Text>
    </FlexBox>
);

interface StepHeaderBackButtonProps {
    readonly text?: string;
    readonly onClick: () => void;
}

const StepHeaderBackButton = ({ text = 'Go back', onClick }: StepHeaderBackButtonProps) => {
    const track = useTrack();
    const router = useRouter();

    const handleClick = () => {
        track(AnalyticsEvent.signupBack, { source: router.pathname });
        onClick();
    };

    return (
        <Button variant="link" intent="primary" type="button" size="flush" onClick={handleClick}>
            {`← ${text}`}
        </Button>
    );
};

AuthStepHeader.BackButton = StepHeaderBackButton;

export default AuthStepHeader;
